import { render, staticRenderFns } from "./FaseSelect.vue?vue&type=template&id=04e04ec6"
import script from "./FaseSelect.vue?vue&type=script&lang=js"
export * from "./FaseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports